import { render, staticRenderFns } from "./shuidian.vue?vue&type=template&id=081b2957"
import script from "./shuidian.vue?vue&type=script&lang=js"
export * from "./shuidian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports